import React from "react";
import { useNavigate } from 'react-router-dom';

import { useOnboarding } from "../../context/OnboardingContext";

const SellerRegisCompleted = ( ) => {
    const navigate = useNavigate();
   const { qris } = useOnboarding();



  return (
    <div className="completedscreen flex-center">
        <div className="caption position-relative text-center px-32" style={{paddingTop:"120px", marginTop:"260px"}}>
            <img src="assets/images/icon/personsucceed.png" className="position-absolute" style={{top: "-260px", left: "50%", transform: "translateX(-50%)"}}/>
            <div className="text-black text_quicksand">
                <div className="text-32 fw-bold mb-20">
                    Shop Registration Success!
                </div>
                <img src={qris?.qrisImage} alt="QRIS" />
                {/* <div className="mb-64">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                </div> */}
                <button className="btn btn_mart_primary mb-60 text-14" style={{width:"100%", height:"46px"}} onClick={() => navigate("/seller-store")}>Go to my shop</button>
            </div>
        </div>
    </div>
  );
};

export default SellerRegisCompleted;